import { useState } from 'react';
import { SvgIcon } from '../SvgIcon';

/** CUBA header search toggle — opens `.search-full` */
export function Searchbar() {
  const [open, setOpen] = useState(false);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    document.querySelector('.search-full')?.classList.toggle('open', next);
  };

  return (
    <li>
      <span className="header-search">
        <SvgIcon iconId="search" onClick={toggle} />
      </span>
    </li>
  );
}
